<app-header></app-header>

<div class="middle-content-wrap">
    <div class="globalheading">
        <h2>Missing User Data</h2>
    </div>

    <div class="listingformat">
        <div class="tabledatawrap table-responsive">
            <table>
                <thead>
                    <tr>
                        <th>Image</th>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Activity Score</th>
                        <th>Attractiveness Score</th>
                        <th>Gender</th>
                        <th>Date of Birth</th>
                        <th>Nationality</th>
                        <th>Marital Status</th>
                        <th>Child Status</th>
                        <th>Religion</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        *ngFor="let user of userList | paginate: { itemsPerPage: itemsPerPage, currentPage: p, totalItems: total }">
                        <td (click)="goToCustomerDetail(user.id)" style="cursor:pointer">
                            <div class="profile-image" *ngIf="user.profileImage">
                                <img [src]="user.profileImage" alt="Profile" class="user-avatar"
                                    style="width: 50px; height: 50px; object-fit: cover; border-radius: 50%;">
                            </div>
                        </td>
                        <td (click)="goToCustomerDetail(user.id)" style="cursor:pointer">{{ user.id }}</td>
                        <td (click)="goToCustomerDetail(user.id)" style="cursor:pointer">{{ user.name }}</td>
                        <td (click)="goToCustomerDetail(user.id)" style="cursor:pointer">{{ user.email }}</td>
                        <td (click)="goToCustomerDetail(user.id)" style="cursor:pointer">{{ user.activity_score }}</td>
                        <td (click)="goToCustomerDetail(user.id)" style="cursor:pointer">{{ user.attractiveness_score }}
                        </td>
                        <td>
                            <select [(ngModel)]="user.gender" class="form-control table-input">
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                        </td>
                        <td>
                            <input type="date" [(ngModel)]="user.dateOfBirth" class="form-control table-input">
                        </td>
                        <td>
                            <input list="countries" [(ngModel)]="user.nationality" class="form-control table-input"
                                placeholder="Search Country">
                            <datalist id="countries">
                                <option *ngFor="let country of countries" [value]="country.name">{{country.flag}}
                                    {{country.name}}</option>
                            </datalist>
                        </td>
                        <td>
                            <select [(ngModel)]="user.marital_status" class="form-control table-input">
                                <option value="" disabled>Select</option>
                                <option *ngFor="let status of maritalStatusOptions" [value]="status">{{status}}</option>
                            </select>
                        </td>
                        <td>
                            <select [(ngModel)]="user.child_status" class="form-control table-input">
                                <option value="" disabled>Select</option>
                                <option *ngFor="let status of childStatusOptions" [value]="status">{{status}}</option>
                            </select>
                        </td>
                        <td>
                            <select [(ngModel)]="user.religion" class="form-control table-input">
                                <option value="" disabled>Select</option>
                                <option *ngFor="let rel of religionOptions" [value]="rel">{{rel}}</option>
                            </select>
                        </td>
                        <td>
                            <button class="btn btn-primary btn-sm" (click)="saveUser(user)">Save</button>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="userList?.length == 0">
                    <tr>
                        <td colspan="11" class="text-center">No missing data found</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row">
            <div class="col-md-12 custompagination">
                <pagination-controls (pageChange)="onPageChange($event)"></pagination-controls>
            </div>
        </div>
    </div>
</div>